<template>
  <b-card
    no-body
    class="card-developer-meetup "
  >
    <div class="bg-light-primary rounded-top text-center">
      <b-img
        :src="require('@/assets/images/illustration/email.svg')"
        alt="Meeting Pic"
        height="170"
      />
    </div>

    <b-overlay
      :show="loader"
      rounded="sm"
    >
      <b-card-body v-if="!errorContent.status">
        <!-- Detalles básicos de curso -->
        <div class="meetup-header d-flex align-items-center">
          <div class="meetup-day">
            <b-badge
              variant="light-primary"
              class="mb-25"
            >
              {{ curso.claveMateria }}
            </b-badge>
            <b-badge variant="primary">
              {{ nombreModalidad(curso.modalidad) }}
            </b-badge>
          </div>
          <div class="my-auto">
            <b-card-title class="mb-25">
              {{ curso.nombre }}
            </b-card-title>
            <b-card-text class="mb-0">
              <small>{{ curso.objetivo }}</small>
            </b-card-text>
          </div>
        </div>

        <!-- Fecha de inicio -->
        <div class="apply-job-package bg-light-primary rounded p-75 mb-75">
          <div class="text-center">
            <small class="font-weight-bolder">
              {{ timestampToDate(curso.fecha_ini) }}
            </small>
          </div>
        </div>
        <!-- Fecha de fin -->
        <div class="apply-job-package bg-light-danger rounded p-75">
          <div class="text-center">
            <small class="font-weight-bolder">
              {{ timestampToDate(curso.fecha_fin) }}
            </small>
          </div>
        </div>

        <hr class="mb-2">

        <!-- Grupo y periodo -->
        <b-row>
          <b-col cols="6">
            <div class="text-center">
              <h6 class="text-muted font-weight-bolder">
                Grupo
              </h6>
              <h3 class="mb-0 text-center">
                {{ curso.grupo }}
              </h3>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="text-center">
              <h6 class="text-muted font-weight-bolder">
                Periodo
              </h6>
              <h3 class="mb-0">
                {{ curso.periodo }}
              </h3>
            </div>
          </b-col>
        </b-row>
      </b-card-body>
      <b-card-body v-else>
        <small class="text-danger"><b>{{ errorContent.message }}</b></small>
      </b-card-body>
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BCard,
  BImg,
  BCardBody,
  BCardText,
  BCardTitle,
  VBTooltip,
  BBadge,
  BRow,
  BCol,
  BOverlay,
} from 'bootstrap-vue'
import { cursoInfo } from '@/views/campus/servicio-escolar/components/edicion-curso/useCursos'
import { timestampToDate, nombreModalidad } from '@core/utils/filter'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BImg,
    BCardBody,
    BCardText,
    BCardTitle,
    BBadge,
    BRow,
    BCol,
    BOverlay,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      cursoInfo,
      nombreModalidad,
      timestampToDate,
      curso: {},
      loader: false,
      errorContent: {},
    }
  },
  mounted() {
    //* Load course data
    this.loader = true
    this.cursoInfo(this.$route.params.curso).then(response => {
      this.loader = false
      this.curso = response.curso
    }, error => {
      this.loader = false
      this.errorContent.status = true
      this.errorContent.message = error
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Error en petición [Información de curso]',
          text: error,
          icon: 'AlertCircleIcon',
          variant: 'danger',
        },
      },
      { timeout: 10000 })
    })
  },
}
</script>
